import { info, record, abnormal } from './tableColumn';
import config from './config.js';
import dayjs from 'dayjs';
export default {
    created() {
        this.initRouter();
    },
    activated() {
        this.initRouter(true);
    },
    data() {
        return {
            config,
            initSearchInfo: {}, // 用于设置初始默认值
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            visible: false, // 弹窗
            options: [], // 弹窗站点下拉选项
            saveLoading: false, // 保存loading
            activeName: 'info', // tabs页
            isDetail: false, // 双击详情页
            infoData: [], // 运输单信息table
            infoTableColumn: info, // 运输单信息column
            recordData: [], // 历史跟踪记录table
            recordTableColumn: record, // 历史跟踪记录column
            abnormalData: [], // 异常信息table
            abnormalTableColumn: abnormal, // 异常信息column
            recordLoading: false, // 历史跟踪记录loading
            abnormalLoading: false, // 历史跟踪记录loading
            abnormalSelection: [], // 异常信息已选项
            recordSelection: [], // 历史跟踪记录已选项
            abnormalOptions: [], // 异常类型列表
            ruleForm: {
                etdsNo: '',
                etdoRemark: '',
                etdoNo: ''
            },
            rules: {
                etdsNo: [
                    { required: true, message: '请选择站点', trigger: 'change' }
                ],
                adder: [
                    { required: true, message: '请选择地址', trigger: 'change' }
                ]
            },
            recordAddVisible: false, // 新增跟踪记录弹窗
            abnormalAddVisible: false, // 新增跟踪记录弹窗
            ruleRecordForm: {
                etisIsAbnormal: '', // 是否异常
                etisRemark: '', // 备注
                adder: '', // 省市
                etisLocationdetail: '' // 详细地址
            },
            ruleAbnormalForm: {
                ettgAbnormalClass: '', // 异常分类
                ettgAbnormalType: '', // 异常类型
                ettgEtisLocation: '', // 跟踪地点名称
                ettgRemark: '' // 备注
            }
        };
    },
    methods: {
        initRouter(isCache) {
            if (this.$route.query.etdoStatus) {
                this.initSearchInfo = {
                    etdoStatus: this.$route.query.etdoStatus
                };
                this.$router.replace(this.$route.path);
            }
            if (isCache) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm') : '',
                ...data
            };
            delete tempData.createTime;
            return tempData;
        },
        handleSelectionChange(val) {
            this.abnormalSelection = val;
        },
        handleSelectionRecordChange(val) {
            this.recordSelection = val;
        },
        pageChange(val) {
            this.currentPage = val;
            this._getList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getList();
        }
    }
};